import Interpretation from './Interpretation'

export default Interpretation



// WEBPACK FOOTER //
// ./src/legacy/components/Interpretation/index.js